import React from 'react';
import { Switch } from './ds/fgcp-ds.jsx';
import { api } from '../api.js';
import { Empty, Loading, Modal } from './components.jsx';

// 내 알림 설정 — 이벤트 × 채널(Teams·메일). 화면 알림(종 아이콘)은 항상 남는다.
const CH_LABEL = { teams: 'Teams', mail: '메일', teams_feed: 'Teams 활동' };

function NotifySettings({ onClose, onToast }) {
  const [data, setData] = React.useState(null);
  const [err, setErr] = React.useState('');
  React.useEffect(() => { api.get('/api/v1/notifications/preferences').then(setData).catch(e => setErr(e.message)); }, []);
  const toggle = async (event, channel, enabled) => {
    setData(d => ({ ...d, items: d.items.map(i => i.event === event ? { ...i, channels: { ...i.channels, [channel]: enabled } } : i) }));
    try { await api.put('/api/v1/notifications/preferences', { event, channel, enabled }); }
    catch (e) {
      onToast(e.message);
      setData(d => ({ ...d, items: d.items.map(i => i.event === event ? { ...i, channels: { ...i.channels, [channel]: !enabled } } : i) }));
    }
  };
  return (
    <Modal width={460} title="알림 설정" icon="bell" onClose={onClose}>
      {err ? <Empty title="설정을 불러오지 못했습니다" sub={err} /> : !data ? <Loading title="불러오는 중" /> : (
        <div>
          <div style={{ fontSize: 12, color: 'var(--ink-3)', marginBottom: 12 }}>화면 알림(종 아이콘)은 항상 받습니다. Teams 채팅·메일·Teams 활동(피드)은 종류별로 켜고 끌 수 있습니다.</div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
            <thead><tr style={{ color: 'var(--ink-3)', fontSize: 11 }}>
              <th style={{ textAlign: 'left', padding: '6px 4px', fontWeight: 600 }}>알림</th>
              {data.channels.map(c => <th key={c} style={{ width: 70, fontWeight: 600 }}>{CH_LABEL[c] ?? c}</th>)}
            </tr></thead>
            <tbody>{data.items.map(i => (
              <tr key={i.event} style={{ borderTop: '1px solid var(--line)' }}>
                <td style={{ padding: '9px 4px' }}>{i.label}</td>
                {data.channels.map(c => (
                  <td key={c} style={{ textAlign: 'center' }}>
                    <Switch size="sm" aria-label={`${i.label} ${CH_LABEL[c]}`} checked={Boolean(i.channels[c])} onChange={v => toggle(i.event, c, v)} />
                  </td>))}
              </tr>))}
            </tbody>
          </table>
        </div>)}
    </Modal>
  );
}

export { NotifySettings };
